import { useEffect, useState } from 'react';

/** The zoom menu's percentage: the plan or the 3D view on screen publishes it, `useViewZoom` reads it. */
export const VIEW_ZOOM_EVENT = 'hp:view-zoom';

let shown: number | null = null;

/** Sent only when the rounded value changes, so a frame that moved nothing sends nothing. */
export function publishViewZoom(percent: number | null): void {
  if (percent === shown || typeof window === 'undefined') return;
  shown = percent;
  window.dispatchEvent(new CustomEvent<number | null>(VIEW_ZOOM_EVENT, { detail: percent }));
}

export function useViewZoom(): number | null {
  const [percent, setPercent] = useState(shown);
  useEffect(() => {
    const update = (event: Event) => setPercent((event as CustomEvent<number | null>).detail);
    window.addEventListener(VIEW_ZOOM_EVENT, update);
    setPercent(shown);
    return () => window.removeEventListener(VIEW_ZOOM_EVENT, update);
  }, []);
  return percent;
}
